import { createContext } from 'react';
import { IItemForGetShortInfoWithStatus, RestaurantNotificationEventType, ICreateScheduledPush } from 'types';

export type TTypeOfCreateScheduleModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';

export interface ICreateScheduleState {
	pushType: RestaurantNotificationEventType | null;
	schedule: string;
	fetchedRestaurants: IItemForGetShortInfoWithStatus[];
	IDsSelectedRestaurant: string[];
	dataForSubmit: ICreateScheduledPush | null;
	typeOfModalWindow: TTypeOfCreateScheduleModalWindow;
}

export const createScheduleInitialState: ICreateScheduleState = {
	pushType: null,
	schedule: '',
	fetchedRestaurants: [],
	IDsSelectedRestaurant: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateScheduleContext extends ICreateScheduleState {
	setPushType(value: RestaurantNotificationEventType | null): void;
	changeSchedule(value: string): void;
	setFetchedRestaurants(value: IItemForGetShortInfoWithStatus[]): void;
	setIDsRestaurant(value: string[]): void;
	setDataForSubmit(value: ICreateScheduledPush | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateScheduleModalWindow): void;
	resetFields(): void;
}

export const CreateScheduleContext = createContext<ICreateScheduleContext>({
	setPushType: () => undefined,
	changeSchedule: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createScheduleInitialState,
});
